import {ATTACHMENT_TYPES} from '../../../configs/AttachmentTypes'

export default {
  termAndConditions: ATTACHMENT_TYPES.TERMS_AND_CONDITIONS_ACCEPTANCE
}
